<router-outlet>
  <div *ngIf="loaderService.isLoading$ | async" class="loader-spinner">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</router-outlet>
